import { phoneRegex } from "@/components/Forms/schema/addPhoneNumberSchema.ts";
import { dayjsLocalDateSchema } from "@/utils/zod.ts";
import { localDateTransformer } from "@/utils/zodTransformers";
import { z } from "zod";
import { zj } from "zod-joda";

export const formatPhoneNumber = (value: string | null | undefined): string | null => {
    if (!value) {
        return null;
    }

    let cleaned = value.replace(/\D/g, "");

    if (cleaned.length === 11 && cleaned.startsWith("1")) {
        cleaned = cleaned.slice(1);
    }

    if (cleaned.length !== 10) {
        return value;
    }

    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export const personSchema = z.object({
    idUUID: z.string(),
    id: z.number(),
    role: z.string().optional().nullable(),
    nameFirst: z.string().optional().nullable(),
    nameLast: z.string().optional().nullable(),

    namePrefix: z.string().optional().nullable(),
    nameI: z.string().optional().nullable(),
    nameAKA: z.string().optional().nullable(),
    nameSuffix: z.string().optional().nullable(),
    crmStatus: z.string().optional().nullable(),
    race: z.string().optional().nullable(),
    sex: z.string().optional().nullable(),
    ssnumber: z.string().optional().nullable(),
    taxIDNumber: z.string().optional().nullable(),
    dlNumber: z.string().optional().nullable(),
    dlissuedBy: z.string().optional().nullable(),
    dateofbirth: localDateTransformer,
    dateofdeath: localDateTransformer,
    idReferredBy: z.string().optional().nullable(),
    idSourceView: z.string().optional().nullable(),
    idSource: z.string().optional().nullable(),

    primaryPhoneNumber: z.string().optional().nullable(),
    phoneExtension: z.string().optional().nullable(),

    emergencyContactPhone1: z
        .string()
        .optional()
        .nullable()
        .transform((val) => formatPhoneNumber(val)),
    emergencyContactPhone2: z
        .string()
        .optional()
        .nullable()
        .transform((val) => formatPhoneNumber(val)),
    emergencyContactName1: z.string().optional().nullable(),
    emergencyContactName2: z.string().optional().nullable(),

    legalGuardianName: z.string().optional().nullable(),
    legalGuardianPhone: z.string().optional().nullable(),
    legalGuardianEmail: z.string().optional().nullable(),
});

export const savePersonSchema = personSchema.extend({
    dateofbirth: dayjsLocalDateSchema.nullable(),
    dateofdeath: dayjsLocalDateSchema.nullable(),
    legalGuardianName: z.string().optional().nullable(),
    legalGuardianPhone: z.string().optional().nullable(),
    legalGuardianEmail: z.string().optional().nullable(),

    emergencyContactPhone1: z
        .string()
        .nullable()
        .optional()
        .refine((val) => !val || phoneRegex.test(val), {
            message: "If provided, phone number must be in format (XXX) XXX-XXXX",
        }),
    emergencyContactPhone2: z
        .string()
        .nullable()
        .optional()
        .refine((val) => !val || phoneRegex.test(val), {
            message: "If provided, phone number must be in format (XXX) XXX-XXXX",
        }),
});

export const savePersonOnCaseSchema = savePersonSchema.extend({
    emergencyContactPhone1: z.string().nullable().optional(),
    emergencyContactPhone2: z.string().nullable().optional(),
});

export const addPersonSchema = z.object({
    role: z.string(),
    nameFirst: z.string(),
    nameLast: z.string(),

    namePrefix: z.string().nullable().optional(),
    nameI: z.string().nullable().optional(),
    nameSuffix: z.string().nullable().optional(),
    nameAKA: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    address2: z.string().nullable().optional(),
    city: z.string().nullable().optional(),
    state: z.string().nullable().optional(),
    zip: z.string().nullable().optional(),
    primaryPhoneNumber: z.string().nullable().optional(),
    phoneExtension: z.string().nullable().optional(),
    faxNumber: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
});

export const testPersonSchema = z.object({
    idUUID: z.string().optional().nullable(),
    id: z.number().optional().nullable(),
    dateofbirth: zj.localDate().nullable(),
});
